import {
  TModelValueType,
} from './input-qmulus-dashboard-widget-limit.ts';

const modelValueType: Record<TModelValueType, string> = {
  auto: 'Automatyczny',
  value: 'Statyczny',
  factoredLimit: 'Dynamiczny',
};

export default {
  modelValueType,
};
